<template>
  <div class="basic-bar-skeleton">
    <SkeletonHeader />
    <div class="basic-bar-skeleton__row-list">
      <div
        v-for="(w, key) in rowsWidths"
        :key="key"
        class="basic-bar-skeleton__row"
      >
        <v-skeleton-loader
          type="text"
          :style="{ width: `${w}%` }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SkeletonHeader } from '@/components/base';

export default {
  name: 'BasicBarSkeleton',
  components: {
    SkeletonHeader,
  },
  data() {
    return {
      rowsWidths: [
        95,
        65,
        80,
        40,
        50,
        65,
        45,
        30,
        75,
        90,
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .basic-bar-skeleton {
    &__row-list {
      display: flex;
      flex-wrap: wrap;
      row-gap: 20px;
    }

    &__row {
      width: 100%;

      .v-skeleton-loader {
        .v-skeleton-loader__bone::after {
          border-radius: 0;
          height: 20px;
          background:
            linear-gradient(
              90deg,
              rgba(255, 255, 255, 0),
              rgba(255, 255, 255, 0.6),
              rgba(255, 255, 255, 0)
            );
        }

        .v-skeleton-loader__text {
          border-radius: 0;
          height: 20px;
          background:
            linear-gradient(
              90deg,
              rgba(245, 245, 245, 1) 0%,
              rgba(210, 210, 212, 1) 75%,
              rgba(210, 210, 212, 0) 100%,
            );
        }
      }
    }
  }
}
</style>
